export const removeSpecialCharacters = (data: string) => {
    return data?.replace(/[^\d]/g, '')
}
